import type { FC } from 'react';
import { BaseIcon } from '@/Module/Icon/Component/BaseIcon';
import type { IIconProps } from '@/Module/Icon/Model';
export const IconGradOne: FC<IIconProps> = props => {
  return <BaseIcon {...props} data-sentry-element="BaseIcon" data-sentry-component="IconGradOne" data-sentry-source-file="IconGradOne.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="23" viewBox="0 0 6 23" fill="none" data-sentry-element="svg" data-sentry-source-file="IconGradOne.tsx">
        <path d="M3.48422 22.06C3.42422 15.64 3.18422 9.13 0.664219 1.24L2.49422 0.37C4.83422 7.42 5.34422 14.32 5.34422 22.06H3.48422Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="IconGradOne.tsx" />
      </svg>
    </BaseIcon>;
};